(() => {
  if (window.__sokAltLocalizationLoaded) return;
  window.__sokAltLocalizationLoaded = true;

  const detectLang = () => {
    let lang = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
    const p = location.pathname || '';
    if (p.startsWith('/de/')) lang = 'de';
    else if (p.startsWith('/nl/')) lang = 'nl';
    else if (p.startsWith('/sv/')) lang = 'sv';
    return ['en','de','nl','sv'].includes(lang) ? lang : 'en';
  };

  const copy = {
    en: {
      hero: ['SOK LiFePO4 batteries for RV marine and off-grid systems','SOK LiFePO4 battery system with Victron energy equipment','Serviceable SOK LiFePO4 batteries designed for long-term use'],
      collection: ['12V LiFePO4 batteries for RV marine and off-grid','24V LiFePO4 batteries for RV marine and off-grid systems','48V LiFePO4 battery storage for solar and off-grid systems','LiFePO4 battery chargers and accessories for SOK battery systems'],
      application: ['LiFePO4 battery installed in an RV off-grid power system','LiFePO4 marine battery powering onboard electrical systems','LiFePO4 battery storage for an off-grid solar power system','48V LiFePO4 battery storage for home solar energy'],
      gallery: ['SOK LiFePO4 battery home energy installation','SOK LiFePO4 battery system with Victron equipment','SOK LiFePO4 battery installed in an RV electrical bay','SOK rack LiFePO4 battery energy storage installation','SOK LiFePO4 battery system installed in a campervan','SOK LiFePO4 battery customer installation'],
      aplus: 'product feature'
    },
    de: {
      hero: ['SOK LiFePO4 Batterien für Wohnmobil Boot und Off-Grid','SOK LiFePO4 Batteriesystem mit Victron Komponenten','Wartungsfreundliche SOK LiFePO4 Batterien für langfristige Nutzung'],
      collection: ['12V LiFePO4 Batterien für Wohnmobil Camper und Boot','24V LiFePO4 Batterien für Wohnmobil und Off-Grid-Systeme','48V LiFePO4 Batteriespeicher für Solar und Off-Grid','LiFePO4 Ladegeräte und Zubehör für SOK Batteriesysteme'],
      application: ['LiFePO4 Batterie im Wohnmobil für autarke Stromversorgung','LiFePO4 Bootsbatterie für Bordstrom und Marine-Elektronik','LiFePO4 Solarbatterie für ein Off-Grid Solarsystem','48V LiFePO4 Batteriespeicher für Solarenergie zu Hause'],
      gallery: ['SOK LiFePO4 Batterie in einem Energiespeichersystem zu Hause','SOK LiFePO4 Batteriesystem mit Victron Komponenten','SOK LiFePO4 Batterie im Elektrikfach eines Wohnmobils','SOK Rack-LiFePO4 Batteriespeicher Installation','SOK LiFePO4 Batteriesystem in einem Campervan','SOK LiFePO4 Batterie Kundeninstallation'],
      aplus: 'Produktmerkmal'
    },
    nl: {
      hero: ['SOK LiFePO4 accu’s voor camper boot en off-grid','SOK LiFePO4 accusysteem met Victron apparatuur','Servicevriendelijke SOK LiFePO4 accu’s voor langdurig gebruik'],
      collection: ['12V LiFePO4 accu’s voor camper boot en off-grid','24V LiFePO4 accu’s voor camper en off-grid systemen','48V LiFePO4 energieopslag voor zonne-energie en off-grid','LiFePO4 laders en accessoires voor SOK accusystemen'],
      application: ['LiFePO4 accu in camper voor off-grid stroomvoorziening','LiFePO4 bootaccu voor boordstroom en maritieme elektronica','LiFePO4 accu voor een off-grid zonne-energiesysteem','48V LiFePO4 energieopslag voor zonne-energie thuis'],
      gallery: ['SOK LiFePO4 accu in energieopslagsysteem voor thuis','SOK LiFePO4 accusysteem met Victron apparatuur','SOK LiFePO4 accu in elektrische ruimte van een camper','SOK rack LiFePO4 energieopslag installatie','SOK LiFePO4 accusysteem in een campervan','SOK LiFePO4 accu klantinstallatie'],
      aplus: 'productfunctie'
    },
    sv: {
      hero: ['SOK LiFePO4-batterier för husbil båt och off-grid','SOK LiFePO4-batterisystem med Victron-utrustning','Servicevänliga SOK LiFePO4-batterier för långvarig användning'],
      collection: ['12 V LiFePO4-batterier för husbil båt och off-grid','24 V LiFePO4-batterier för husbil och off-grid-system','48 V LiFePO4 energilagring för solenergi och off-grid','LiFePO4-laddare och tillbehör för SOK batterisystem'],
      application: ['LiFePO4-batteri i husbil för off-grid strömförsörjning','LiFePO4 båtbatteri för elsystem och elektronik ombord','LiFePO4-batteri för off-grid solenergisystem','48 V LiFePO4 energilagring för solenergi i hemmet'],
      gallery: ['SOK LiFePO4-batteri i energilagringssystem för hemmet','SOK LiFePO4-batterisystem med Victron-utrustning','SOK LiFePO4-batteri i elsystem för husbil','SOK rackmonterad LiFePO4 energilagring installation','SOK LiFePO4-batterisystem installerat i campervan','SOK LiFePO4-batteri kundinstallation'],
      aplus: 'produktfunktion'
    }
  };

  const setByIndex = (selector, values) => {
    document.querySelectorAll(selector).forEach((img, i) => {
      const value = values[i % values.length];
      if (value) img.setAttribute('alt', value);
    });
  };

  const run = () => {
    const lang = detectLang();
    const c = copy[lang];
    setByIndex('.sok-hero__slide .sok-hero__image', c.hero);
    setByIndex('.sok-collection-link__media img', c.collection);
    setByIndex('.sok-application__media img', c.application);
    setByIndex('.sok-gallery__item img', c.gallery);

    const productTitle = document.querySelector('.product__title h1')?.textContent?.trim() || document.querySelector('h1')?.textContent?.trim() || 'SOK LiFePO4';
    document.querySelectorAll('.sok-aplus__module').forEach((module, i) => {
      const img = module.querySelector('.sok-aplus__image');
      if (!img) return;
      const heading = module.querySelector('h3')?.textContent?.trim();
      const alt = heading ? `${productTitle} — ${heading}` : `${productTitle} — ${c.aplus} ${i + 1}`;
      img.setAttribute('alt', alt);
    });
  };

  let queued = false;
  const queue = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; run(); });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  else run();
  document.addEventListener('shopify:section:load', queue);
  new MutationObserver(queue).observe(document.documentElement, { childList: true, subtree: true });
})();